import { Loadable } from '../../Loadable';

export const AsyncEditCategory = Loadable(() => import('./EditCategory'));
export const AsyncListLocations = Loadable(() => import('./ListLocations'));
